import { useState } from "react";
import { FileDown, UserX, Loader2 } from "lucide-react";
import { adminPrivacyExport, adminPrivacyErase } from "../../lib/api";
import { toast } from "../../hooks/use-toast";

// GDPR actions for one customer row (Admin → Clienti → ⋯ menu): export JSON / erase everywhere.
export function GdprMenuItems({ c, className, onDone }) {
  const [busy, setBusy] = useState("");
  const who = c.name || c.phone || c.email || "questo cliente";
  const exportData = async () => {
    setBusy("export");
    try {
      const data = await adminPrivacyExport(c.phone, c.email);
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `dati-${(c.name || "cliente").replace(/\s+/g, "_").toLowerCase()}.json`;
      a.click();
      URL.revokeObjectURL(a.href);
      toast({ title: "Dati esportati", description: "File JSON pronto da inviare al cliente (art. 15 GDPR)" });
    } catch (e) { toast({ title: "Errore export", description: e?.response?.data?.detail || e.message }); }
    finally { setBusy(""); onDone?.(); }
  };
  const erase = async () => {
    const reason = window.prompt(`CANCELLAZIONE GDPR di ${who}\n\nVerranno eliminati account fedeltà, scheda cliente e storico messaggi; prenotazioni e ordini restano in archivio ma resi anonimi (obblighi fiscali). Il contatto viene messo in Non-Contattare.\n\nScrivi il motivo (es. "richiesta via email del 13/10") per confermare:`, "");
    if (!reason) return;
    setBusy("erase");
    try {
      const r = await adminPrivacyErase(c.phone, c.email, reason);
      const n = Object.values(r.report || {}).reduce((s, v) => s + (v.deleted || 0) + (v.anonymized || 0), 0);
      toast({ title: "Dati cancellati", description: `${n} record eliminati o resi anonimi. Registrato nel log privacy.` });
    } catch (e) { toast({ title: "Errore cancellazione", description: e?.response?.data?.detail || e.message }); }
    finally { setBusy(""); onDone?.(true); }
  };
  return (
    <>
      <button onClick={exportData} disabled={!!busy} className={className} data-testid={`customer-gdpr-export-${c.key}`}>
        {busy === "export" ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4 text-[#7c5a4e]" />} Esporta dati (GDPR)
      </button>
      <button onClick={erase} disabled={!!busy} className={`${className} text-red-700`} data-testid={`customer-gdpr-erase-${c.key}`}>
        {busy === "erase" ? <Loader2 className="h-4 w-4 animate-spin" /> : <UserX className="h-4 w-4" />} Cancella dati (GDPR)
      </button>
    </>
  );
}
